import React, { useCallback } from 'react'
import clsx from 'clsx'
import { AccordionIndexType, useAccordion } from './accordion-context'
import { ArrowIcon, MinusIcon, PlusIcon } from '../icons'

import * as styles from './accordion.module.scss'

type Variant = 'arrow'

type Props = React.ComponentProps<'button'> & {
  index?: AccordionIndexType
  variant?: Variant | null
}

export const AccordionButton = ({
  className,
  children,
  index,
  variant,
  ...props
}: Props) => {
  const [isOpen, setIsOpen] = useAccordion()
  const active = index === isOpen

  const onClick = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    ({ currentTarget: el }) => {
      const newOpen = isOpen === index ? false : index!
      setIsOpen(newOpen)
      if (!newOpen) return
      // scroll element into view
      setTimeout(() => {
        const rect = el.getBoundingClientRect()
        if (rect.top >= 100) return
        const top = rect.top + window.pageYOffset - 100
        window.scrollTo({ top, behavior: 'smooth' })
      }, 0)
    },
    [isOpen]
  )

  return (
    <button
      className={clsx(
        styles.button,
        className,
        variant && styles[`button${variant}`]
      )}
      {...props}
      onClick={onClick}
    >
      {variant !== 'arrow' && (active ? <MinusIcon /> : <PlusIcon />)}
      {children}
      {variant === 'arrow' && <ArrowIcon />}
    </button>
  )
}
